import React, { useEffect, useState } from 'react';
import './player-card-pos.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import Modal from '@/components/modal/modal.component';
import PlayerSelector from '@/components/SHARED/player-selector/player-selector.component';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const PlayerCardPos = ({
  gameData,
  playerList,
  teamMembers,
  selectedPlayer,
  setSelectedPlayer
}) => {

  const [ showPlayerSelect, setShowPlayerSelect ] = useState(false);
  const [ playersToDisplay, setPlayersToDisplay ] = useState({});

  useEffect(() => {
    if (!playerList) return;
    const filteredPlayers = {};
    Object.values(playerList).forEach(player => {
      if (player.status === 'active') {
        filteredPlayers[player.playerId] = player;
      }
    });
    setPlayersToDisplay(filteredPlayers);
  }, [playerList]);

  function choosePlayer(player) {
    console.log(player);
    setSelectedPlayer(player);
    setShowPlayerSelect(false);
  }

  return (
    <div className='player-card-pos g-list-item'>
      <p><b>Selected Player</b></p>
      {
        selectedPlayer ?
          <div className='player-info'>
            <PlayerNameIcon player={selectedPlayer} reverse={true} />
            <div className="g-space-0-5"></div>
            <div className='balance'>Balance: <ImageContainer src="/images/icons/coin.png" className="icon-small" />{selectedPlayer.currency.toLocaleString() || 0}</div>
          </div>
          :
          <div className='player-info'>
            <p><i>No player selected</i></p>
          </div>
      }
      <div className='buttons left'>
        <button 
          className='g-button small-btn' 
          onClick={() => setShowPlayerSelect(true)} > 
          Select Player
        </button>
        {/* <button 
          className='g-button small-btn' >
        <FontAwesomeIcon icon={faBarcode} />
        </button> */}
      </div>
      <Modal
        show={!!showPlayerSelect}
        cancel={() => setShowPlayerSelect(false)}
        text="Select Player"
        closeButton={true} >
        <PlayerSelector
          playerList={playersToDisplay}
          teamMembers={teamMembers}
          chosenPlayers={[selectedPlayer]} 
          togglePlayer={choosePlayer}
          type="player"
          displayArr={['info', 'currency']} />
      </Modal>
    </div>
  )
}

export default PlayerCardPos;